import { render, staticRenderFns } from "./LoyaltyCards.vue?vue&type=template&id=525e5dac"
import script from "./LoyaltyCards.vue?vue&type=script&lang=js"
export * from "./LoyaltyCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports